<template>
  <div>
      <b-overlay :show="isConfirmNeeded" no-wrap>
      <template v-slot:overlay>
        <div
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3 border border-danger rounded"
        >
          <p>
            <strong id="form-confirm-label">Please remove the existing users before deleting the user role </strong>
          </p>
          <div class=" mx-auto">
            <b-button variant="outline-danger" class="mr-3" @click="isDeletePopUp">Cancel</b-button>
            <b-button variant="outline-success" @click="onOK">OK</b-button>
          </div>
        </div>
      </template>
    </b-overlay>

    <b-card style="margin:20px">
     
        <b-row>
          <b-col cols="2" style="width:300px">
            <Sidebar></Sidebar>
          </b-col>
            <div class="mr-1" style="border:solid;width:1px"></div>
        <b-col cols="9">

            <b-row>
                <b-col cols="4">
                <b-form-group
                class="text-align"
                 style="margin-top: 5px;"
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label="Filter By"
                >
                  <b-form-select
                    @change="onFilterTypeChange()"
                    v-model="filterValue"
                    :options="optionsFilter"
                    class="m-md-2"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="4" class="ml-auto">
                <b-form-input   class="m-md-2 " type="search" placeholder="Search"></b-form-input>
              </b-col>
            </b-row>

            <div style="padding-bottom:20px"></div>
            <b-row>
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">User Role</th>
                    <th scope="col">Tasks/ Areas Accessible</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for="role in roles" :key="role.id">
                    <td>{{role.name}}</td>
                    <td>{{role.task}}</td>
                    <td>
                      <b-button  to="/admin/edit-role">Edit</b-button>
                      <span style="padding-left:20px"></span>
                       <b-button @click="isDeletePopUp()">Delete</b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-row>
            <b-row class="text-center">
                <b-col></b-col>
              <b-button to="/admin/add-role" variant="primary">Add New Role</b-button>
               <b-col></b-col>
            </b-row>
          </b-col>
        </b-row>
    
    </b-card>
  </div>
</template>

<script>
import Sidebar from "../AdminSlidebar";

export default {
  name: "RoleManagementMainWindow",
  components: {
    Sidebar
  },
  methods: {
    onFilterTypeChange() {
      console.log(this.filterValue);
    },
    isDeletePopUp() {
      this.isConfirmNeeded = !this.isConfirmNeeded;
    }
  },
  data() {
    return {
      isConfirmNeeded: false,
      filterValue: "a",
      optionsFilter: [
        { value: "a", text: "User Role" },
        { value: "b", text: "Name" }
      ],
      roles: [
        {
          name: "Admin",
          tasks: "admin 123",
          id: 1
        },
        {
          name: "Role 01",
          task: "user 123",
          id: 2
        },
        {
          name: "Role 02",
          task: "user 123",
          id: 3
        },
        {
          name: "Role 03",
          task: "user 123fghfh",
          id: 4
        }
      ]
    };
  }
};
</script>

<style>
</style>